import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { partnerLogos } from "../mock";

const PartnersCarousel = () => {
  const trackRef = useRef(null);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 340, behavior: "smooth" });
  };

  return (
    <div className="relative max-w-7xl mx-auto px-6">
      {/* arrows */}
      <button
        aria-label="Previous"
        onClick={() => scrollBy(-1)}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 h-11 w-11 rounded-full glass-strong flex items-center justify-center text-[#003c7a] hover:text-[#0066b3] transition-colors"
      >
        <ChevronLeft size={22} />
      </button>
      <button
        aria-label="Next"
        onClick={() => scrollBy(1)}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 h-11 w-11 rounded-full glass-strong flex items-center justify-center text-[#003c7a] hover:text-[#0066b3] transition-colors"
      >
        <ChevronRight size={22} />
      </button>

      <div
        ref={trackRef}
        className="flex gap-5 overflow-x-auto scroll-smooth py-2 px-10 no-scrollbar"
        style={{ scrollbarWidth: "none" }}
      >
        {partnerLogos.map((p) => (
          <a
            key={p.name}
            href={p.link}
            target="_blank"
            rel="noopener noreferrer"
            title={p.name}
            className="group shrink-0 w-[230px] h-[130px] glass rounded-2xl border border-white/60 flex items-center justify-center p-6 card-hover"
          >
            <img
              src={p.img}
              alt={p.name}
              className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default PartnersCarousel;
